/**
 * Note: this is an eventual replacement for classNames in the ES6 world
 *
 * Creates a class name string by conditionally combining all of the classes
 * in the given object.
 *
 * @param {?Object<string, boolean>=} classes A mapping from class name to their current toggle value
 * @return {string} All toggled class names
 * @author Sugat Poudel (spoudel@yext.com)
 */
export function classNames(classes = {}) {
  const toggledClasses = [];
  for (const className in classes) {
    if ({}.hasOwnProperty.call(classes, className)) {
      if (classes[className]) {
        toggledClasses.push(className);
      }
    }
  }
  return toggledClasses.join(' ');
}
